export default function AccountHeader() {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.accessToken) {
    // return { Authorization: 'Bearer ' + user.accessToken };
    return { "x-access-token": user.accessToken };
  } else {
    return {};
  }
}